// Enum for Personality Types
export const PERSONALITY_TYPES = {
  NOT_AVAILABLE: "N/A",
  DESIGNER: "Designer",
  LEADER: "Leader",
  DRIVER: "Driver",
  CREATOR: "Creator",
  PERSUADER: "Persuader",
  MOTIVATOR: "Motivator",
  PROMOTER: "Promoter",
  COLLABORATOR: "Collaborator",
  ADVOCATE: "Advocate",
  PROPONENT: "Proponent",
  COORDINATOR: "Coordinator",
  EQUALIZER: "Equalizer",
  MANAGER: "Manager",
  STRATEGIST: "Strategist",
  CHALLENGER: "Challenger",
  INVESTIGATOR: "Investigator",
};

// Enum for Sort Audience -> Lists
export const SORT_TYPES = {
  LAST_MODIFIED: 0,
  MOST_ENGAGED: 1,
  ALPHABETS: 2,
};

export const IPERSONALITY_TYPES = [
  { name: "N/A", color: "#000000" },
  { name: "Designer", color: "#a94255" },
  { name: "Leader", color: "#ed1012" },
  { name: "Driver", color: "#ff0000" },
  { name: "Creator", color: "#ff6700" },
  { name: "Persuader", color: "#ff8a00" },
  { name: "Motivator", color: "#ffb136" },
  { name: "Promoter", color: "#ceaf15" },
  { name: "Collaborator", color: "#85af35" },
  { name: "Advocate", color: "#58b048" },
  { name: "Proponent", color: "#01b16d" },
  { name: "Coordinator", color: "#00b79b" },
  { name: "Equalizer", color: "#00b8b7" },
  { name: "Manager", color: "#06bad2" },
  { name: "Strategist", color: "#00c1fd" },
  { name: "Challenger", color: "#3e91c1" },
  { name: "Investigator", color: "#6f6b8f" },
];
